/***********************************************************
Alexander Self
8/22/17
Gang Create: Create gangs(teams of employees)
***********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EmployeeList from '../../employee_list';
import { addGangMember, removeGangMember, gangAutocomplete, createGang } from '../../../actions/team_actions';
import { mapEmployeeForAutoComplete, findEmployeeByName } from '../../../utils';
import { AutoComplete } from '../../inputs';
import EmployeeTable from '../../employee_table';
import TeamBuilderForm from './team_builder_form';

class GangCreate extends Component {
  render() {
    return (
      <div className="row">
        <blockquote><span className="flow-text">Team Create</span></blockquote>
        <div className="col s12 m12 l2 xl2">
          <AutoComplete id={'employee-gang-builder'} label={'Find Employee'}
            data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={(val, id) => this.props.gangAutocomplete(findEmployeeByName(val, this.props.employees), id)} />
          <div className="emp-list">
            <div className="card">
              <EmployeeList employees={this.props.employees} icon={'person_add'} header={'Add Employees'}
                onClick={(e) => this.props.addGangMember(e)} _class={'green'} isEditOrDelete={true} />
            </div>
          </div> <hr />
        </div>
        <div className="col s12 m12 l10 xl10">
          <TeamBuilderForm onClick={() => this.props.createGang(this.props.gangMembers, this.props.gangs)} />
          <div className="row scrollable">
            Team Count: <b>{ this.props.count }</b>
            { this.props.gangMembers.length > 0 ?
              <EmployeeTable employees={this.props.gangMembers} onClick={this.props.removeGangMember} />
              : ''
            }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    employees: state.gang.employees,
    gangMembers: state.gang.create.gangMembers,
    count: state.gang.create.count,
    gangs: state.gang.gangs
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addGangMember,
    removeGangMember,
    gangAutocomplete,
    createGang
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GangCreate);











































/* END */



// WEBPACK FOOTER //
// ./src/components/teams/create/team_create.js